import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,
        DownloadTemplate,DynamicListArea,BulkEdit,
        LoadGraphic,AddListItem,Step} from '../components/Common';
import {Input,TextButton,Button, CheckboxList} from '../components/Input';
import u from '../utilities/Utilities';

export default class QualificationList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Qualifications",
        permission:"training",  //Accepts combined permission module as well
        //combinedField:"",          //Used when permission exists in a combined field
        url:"/qualification-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/add-qualification-entry",
        templateURL:"/api/get-add-qualification-template",
        bulkURL:"/api/add-bulk-qualification-entries",
        deleteURL:"/api/delete-qualification-entries",
        spreadsheetURL:"/api/generate-qualification-spreadsheet",
        overviewURL:"/api/get-all-qualification-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"qualification-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        download:{component:DownloadTemplate,props:{skipParams:true}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:(permissions.create==2)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ]
        })
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>

                <div className="page-error">{this.state.error}</div>

                <PageMenu ref={(ref)=>{this.r['pageMenu']=ref}}
                          buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index}
                                          index={index}
                                          content={content}
                                          onChange={onChange}
                                          onContentChange={onContentChange}
                                          registerReference={registerRef}
                                          permissions={this.state.permissions}
                                          settings={this.settings}
                                          />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{
    r={};

    state={
        error:"",
        step:"view",
        loading:false,
        loadText:"",
        trainingCourseOptions:[],
    };

    onUpdateCourse=async ()=>{
        try{
            this.setState({loading:true,loadText:"Preparing..."});
            const response = await u.postAsync({url:"/api/get-existing-training-courses"});
            const {content}=this.props;
            const trainingCourseOptions=response.data.filter((item)=>{
                const selected = (content.courseTitle.filter((selectedItem)=>{
                    return (item == selectedItem);
                }).length > 0);

                return !selected;
            }).map((item)=>{
                return {
                    label:item,
                }
            });

            this.setState({
                trainingCourseOptions:trainingCourseOptions,
                loading:false,
                step:"courses"
            })
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onConfirmQualifying=async ()=>{
        const interest = this.r['qualifying'].getInterest();

        const selected = interest.filter((item)=>{
            return item.selected;
        }).map((item)=>{
            return item.label;
        });

        const {content}=this.props;
        const newValue = content.courseTitle.concat(selected).sort();

        try{
            this.setState({loading:true,loadText:"Updating..."});
            await u.postAsync({
                url:"/api/update-qualification-info",
                data:{
                    id:content.qualificationID,
                    oldValue:content.courseTitle,
                    newValue:newValue,
                    field:"courseTitle",
                }
            });
            this.props.onChange(newValue,"courseTitle",this.props.index);
            this.setState({loading:false,step:"view",error:""});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onRemoveCourse=(contentIndex)=>{
        let {content}=this.props;
        this.onConfirm =async ()=>{
            this.setState({loading:true,loadText:"Updating..."});
            let newValue = JSON.parse(JSON.stringify(content.courseTitle));
            newValue.splice(contentIndex,1);
            await u.postAsync({
                url:"/api/update-qualification-info",
                data:{
                    id:content.qualificationID,
                    oldValue:content.courseTitle,
                    newValue:newValue,
                    field:"courseTitle",
                }
            });
            this.props.onChange(newValue,"courseTitle",this.props.index);
            this.setState({loading:false,step:"view",error:""})
        }

        this.setState({step:"remove",toRemoveIndex:contentIndex});
    }

    render=()=>{
        const {content,settings,permissions}=this.props;
        const {trainingCourseOptions}=this.state;
        const canEdit=(permissions.update==2);

        return (
            <div style={{textAlign:"center"}}>

                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <Step active={this.state.step=="view"}>
                    <DynamicListArea listLabel={settings.listLabel}
                                     permission={settings.permission}
                                     content={content}
                                     onChange={this.props.onChange}
                                     index={this.props.index}
                                     />
                    
                    <div style={{textAlign:"center",margin:"20px auto"}}>
                        <h3>Qualifying Training Titles</h3>

                        <div>
                            <CheckboxList content={content.courseTitle}
                                          headers={[{label:"Course Title"}]}
                                          checkbox={false}
                                          style={{width:"800px",margin:"auto"}}
                                          canRemove={canEdit}
                                          onRemove={this.onRemoveCourse}
                                          />
                        </div>

                        {
                            (canEdit)
                                ?
                                <div style={{margin:"30px auto",textAlign:"center"}}>
                                    <TextButton onClick={this.onUpdateCourse}>Add Qualifying Courses</TextButton>
                                </div>
                                :
                                null
                        }
                    </div>
                </Step>

                <Step active={this.state.step=="courses"}>
                    <h3>Select Qualifying Training</h3>
                    <div>
                        <CheckboxList ref={(ref)=>{this.r['qualifying']=ref}}
                                      content={trainingCourseOptions}
                                      headers={[{value:"label",label:"Course Title"}]}
                                      checkbox={true}
                                      searchable={true}
                                      style={{width:"800px",margin:"auto"}}
                                      />
                    </div>

                    <div style={{margin:"30px auto"}}>
                        <b>Training titles that have already been added are not shown in this list</b>
                    </div>

                    <div style={{margin:"20px auto"}}>
                        <Button onClick={()=>{this.setState({step:"view",error:""})}}>Cancel</Button>
                        <Button onClick={this.onConfirmQualifying}>Add Courses</Button>
                    </div>
                </Step>

                <Step active={this.state.step=="remove"}>
                    <div style={{padding:"20px 0",textAlign:"center"}}>
                        <h2 className='text-negative'>Confirm Remove {content.courseTitle[this.state.toRemoveIndex]}?</h2>
                        <div className='list-segment-note'>Note. This action cannot be undone</div>
                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onConfirm}>Confirm</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{

    settings={
        addType:0,
        addURL:"/api/add-qualification-entry",
        templateURL:"/api/get-add-qualification-template",
        bulkURL:"/api/add-bulk-qualification-entries",
    };

    r={};

    state={
        step:"add",
        entryData:{},
        options:{},
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({error:""});
        }
    }

    componentDidMount=()=>{
        this.getOptions();

        this.show(this.props.active);
    }

    getOptions=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-options",
                data:{
                    keys:[
                        "entryType","trainingCategory"
                    ]
                }
            });

            this.setState({options:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onConfirm=(fields)=>{
        const keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }
        const {entryData}=this.state;
        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onValidated({...entryData,...data});
    }

    onComplete=()=>{
        this.setState({
            entryData:{},
            step:"add"
        });

        if(this.props.onComplete){
            this.props.onComplete();
        }
    }

    onChange=(value,label,index)=>{
        let {entryData}=this.state;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    onBulkUpload=()=>{
        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onBulkUpload()
    }

    render=()=>{
        const {loading,loadText,step,options,entryData}=this.state;

        const fields=[
            {dataType:"box",label:"Qualification Title",field:"qualificationTitle",rules:{required:true}},
            {dataType:"select",label:"Category",field:"category",options:options.trainingCategory},
        ];

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={this.settings}
                         onComplete={this.onComplete}
                         uploadAsJson={false}
                         inList={this.props.miniList}
                         onToggleForm={this.props.onToggleForm}
                         >

                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="add"}>
                        <h3>Complete the following fields to create entry</h3>
                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{
                                                    options:item.options,
                                                    value:entryData[item.field]
                                               }}
                                               fields={{
                                                ...item,
                                                onChange:this.onChange
                                               }}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onConfirm(fields)}}>Confirm</Button>
                        </div>
                    </Step>
                </div>

            </AddListItem>
        )
    }
}
